export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      faculty_name: {
        title: 'Username',
        type: 'string',
        enum: ['1000', '2000', '3000'],
        enumNames: ['Henry Brown', 'John Doe', 'Harold Smith']
      },
      fname: {
        title: 'First Name',
        type: 'string'
      },
      mname: {
        title: 'Middle Name',
        type: 'string'
      },
      lname: {
        title: 'Last Name',
        type: 'string'
      },
      intellcont_auth: {
        type: 'array',
        title: 'Authors',
        items: {
          type: 'object',
          properties: {
            faculty_name: {
              title: 'Username',
              type: 'string',
              enum: ['1000', '2000', '3000'],
              enumNames: ['Henry Brown', 'John Doe', 'Harold Smith']
            },
            fname: {
              title: 'First Name',
              type: 'string'
            },
            mname: {
              title: 'Middle Name',
              type: 'string'
            },
            lname: {
              title: 'Last Name',
              type: 'string'
            }
          }
        }
      }
    }
  },
  uiSchema: {
    intellcont_auth: {
      items: {
        'dm:layout': [{
          type: 'field',
          id: 'faculty_name'
        }, {
          type: 'field',
          id: 'fname'
        }, {
          type: 'field',
          id: 'mname'
        }, {
          type: 'field',
          id: 'lname'
        }]
      },
      'ui:options': {
        itemName: 'Author'
      }
    }
  },
  formData: {},
  triggerData: [{
    sources: ['faculty_name', 'intellcont_auth[].faculty_name', 'intellcont_editor[].faculty_name'],
    targets: ['fname', 'mname', 'lname'],
    data: {
      '1000': ['Henry', '', 'Brown'],
      '2000': ['John', '', 'Doe'],
      '3000': ['Harold', '', 'Smith']
    }
  }]
};